export default "__VITE_ASSET__e18c34b1__"